import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

const EntitiesMenu = () => {
  return (
    <>
      {/* prettier-ignore */}

      <MenuItem icon="asterisk" to="/blog">
        <Translate contentKey="global.menu.entities.blog" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/important-user-details">
        <Translate contentKey="global.menu.entities.importantUserDetails" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/supplement-categories">
        <Translate contentKey="global.menu.entities.supplementCategories" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/supplements">
        <Translate contentKey="global.menu.entities.supplements" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/plan-category">
        <Translate contentKey="global.menu.entities.planCategory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/plans">
        <Translate contentKey="global.menu.entities.plans" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/transaction-details">
        <Translate contentKey="global.menu.entities.transactionDetails" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product-delivery-status">
        <Translate contentKey="global.menu.entities.productDeliveryStatus" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-purchased-plans">
        <Translate contentKey="global.menu.entities.userPurchasedPlans" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/user-purchased-supplements">
        <Translate contentKey="global.menu.entities.userPurchasedSupplements" />
      </MenuItem>
      {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
    </>
  );
};

export default EntitiesMenu;
